// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__vsL5J","addr":"Policy_addr__VS9TN","points":"Policy_points__VFG1p"};